__turbopack_context__.v({
  "authTriggerWrapper": "auth-trigger-block-module-scss-module__KpCPHG__authTriggerWrapper",
});
